export default class AccordionCard {

  constructor(el) {
    this.accordion = el;
    this.toggleLink = this.accordion.find('.js-toggle');
    this.isOpen = false;

    this.handleEvents();
  }

  handleEvents() {
    let self = this;

    this.toggleLink.click(
      this.toggleCard(self)
    );
  }

  toggleCard(self) {
    return function (e) {
      e.preventDefault();
      self.accordion.toggleClass('is-open');
      self.switchLinkContent();
    }
  }

  switchLinkContent() {
    switch (this.isOpen) {
      case false:
        this.toggleLink.html('Fermer la formule');
        this.isOpen = true;
      break;
      case true:
        this.toggleLink.html('Voir la formule');
        this.isOpen = false;
      break;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/accordion-card/index.js